exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ellipsis-multiline[data-v-1339651f]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis}.ellipsis-multiline>img[data-v-1339651f]{width:20px;height:20p;border-radius:50%}.original-price[data-v-1339651f]{text-decoration:line-through}.title[data-v-1339651f]{font-size:20px;font-weight:bold}.type_button[data-v-1339651f]{width:80px;height:30px;background:#fff;margin-right:10px;font-size:14px;border-radius:6px}.selector_button[data-v-1339651f]{font-weight:600;background:#409eff;color:#fff}", ""]);

// exports
